import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import Stack from "@mui/material/Stack";
import { UiButton } from "../../../../../_uiComponents/common/form/UiButton";
import UiTableHead from "../../../../../_uiComponents/common/table/UiTableHead";
// import UiTableHead from "../../../../../_uiMocks/_uiComponents/UiTableHead";
import UiSearch from "../../../../../_uiComponents/common/form/UiSearch";

import { incentiveConfig } from "../../../module.config";
import {
    incentiveAboutContentGetListRequest, incentiveAboutContentPublishRequest,
} from "../../../../../../_redux/_actions";
import { UiAccordian } from "../../../../../_uiComponents/common/form/UiToggleArea";
import { SearchBarWr } from "../../../../../_uiComponents/common/form/UiInputComponents";
import ContentRevisionFilterForm from './forms/ContentRevisionFilterForm';

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function ContentRevision(props) {
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [searchString, setSearchString] = useState("");

     const campaignId = props.campaignId;

     const actionDispatch = useDispatch();

     useEffect(() => {
          getContentRevisionList({});
     }, [page, rowsPerPage, searchString]);

     const getContentRevisionList = () => {
          actionDispatch(
               incentiveAboutContentGetListRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    campaignId,
                    search: searchString,
               }),
          );
     };

     const { tableList, totalRecords } = useSelector((state) => {
          return {
               tableList: state.incentive.contentAboutRevisionList.data,
               totalRecords:
                    state.incentive.contentAboutRevisionList.totalRecords,
          };
     });

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(1);
     };

     //Data sorting
     //  const sortingRows = React.useMemo(
     //       () =>
     //            stableSort(tableList, totalRecords, getComparator(order, orderBy)).slice(
     //                 page * rowsPerPage,
     //                 page * rowsPerPage + rowsPerPage,
     //            ),
     //       [order, orderBy, page, rowsPerPage, tableList],
     //  );

     const setRowPublish = (id) => {
          actionDispatch(
               incentiveAboutContentPublishRequest({ id, campaignId,page,rowsPerPage }),
          );
     };

     return (
          <>
               {/* <div className="sba-content-table-search">
                    <UiSearch
                         onChange={(search) => {
                              setPage(1);
                              setSearchString(search);
                         }}
                    />
               </div> */}
                <div className='sba-content-revision-filter'>
                <UiAccordian>
                    <SearchBarWr>
                        <ContentRevisionFilterForm />
                    </SearchBarWr>
                </UiAccordian>
            </div>
               <div className="sba-table-main-wr sba-campaign-content-table sba-campaign-to-publish-table">
                    <TableContainer component={Paper}>
                         <Table
                              sx={{ minWidth: 650, mt: 0 }}
                              aria-label="simple table"
                              className="sbt-data-grid"
                         >
                              <UiTableHead
                                   headings={
                                        incentiveConfig.creation.content
                                             .contentRevisionTableMap
                                   }
                                   order={order}
                                   orderBy={orderBy}
                                   onRequestSort={handleRequestSort}
                              />
                              <TableBody>
                                   {tableList.map((row, index) => (
                                        <>
                                             <TableRow key={index}>
                                                  {incentiveConfig.creation.content.contentRevisionTableMap.map(
                                                       (
                                                            headCell,
                                                            indexCell,
                                                       ) => {
                                                            if (
                                                                 headCell.isShow
                                                            ) {
                                                                 return headCell.type ==
                                                                      "text" ? (
                                                                      <TableCell
                                                                           key={
                                                                                indexCell
                                                                           }
                                                                           align="center"
                                                                      >
                                                                           {
                                                                                row[
                                                                                headCell
                                                                                     .id
                                                                                ]
                                                                           }
                                                                      </TableCell>
                                                                 ) : (
                                                                      <>
                                                                           {headCell.type ==
                                                                                "version" && (
                                                                                     <TableCell
                                                                                          key={
                                                                                               indexCell
                                                                                          }
                                                                                          align="left"
                                                                                     >
                                                                                          {
                                                                                               row[
                                                                                               headCell
                                                                                                    .id
                                                                                               ]
                                                                                          }
                                                                                     </TableCell>
                                                                                )}

                                                                      </>
                                                                 );
                                                            } else {
                                                            }
                                                       },
                                                  )}

                                                  <TableCell align="center">
                                                       <Stack
                                                            spacing={2}
                                                            direction="row"
                                                            justifyContent="end"
                                                            sx={{
                                                                 width: "100%",
                                                            }}
                                                       >
                                                            <UiButton
                                                                 onClick={() =>
                                                                      props.loadAboutRevisionData(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 name="Load"
                                                                 variant="contained"
                                                                 size="small"
                                                                 color="primary"
                                                            />
                                                            <UiButton
                                                                 onClick={() =>
                                                                      setRowPublish(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 name="Publish"
                                                                 variant="contained"
                                                                 size="small"
                                                                 color="success"
                                                            />
                                                       </Stack>
                                                  </TableCell>
                                             </TableRow>
                                        </>
                                   ))}
                              </TableBody>
                         </Table>
                    </TableContainer>
               </div>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 100]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </>
     );
}
